import { render } from "./FeaturedMessagesPage.vue?vue&type=template&id=46a47d77&scoped=true"
import script from "./FeaturedMessagesPage.vue?vue&type=script&lang=js"
export * from "./FeaturedMessagesPage.vue?vue&type=script&lang=js"

import "./FeaturedMessagesPage.vue?vue&type=style&index=0&id=46a47d77&scoped=true&lang=css"

import exportComponent from "/Users/li/Golang/supergroup.mixin.one/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46a47d77"]])

export default __exports__